// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"b24ea7e4","453":"57d47db4","720":"7cce21b4","777":"c1051056"}[chunkId] + ".chunk.js";
};